<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <CardHeader :title="title" :icon="icon"></CardHeader>
        <md-card-content>
          <div class="md-layout">
            <template>

              <!-- 시작 날짜 폼 -->
              <div class="md-layout-item md-size-25">
                <md-datepicker v-model="startedAt.data">
                  <label> {{ startedAt.label }} </label>
                </md-datepicker>
              </div>

              <!-- 마지막 날짜 폼 -->
              <div class="md-layout-item md-size-25">
                <md-datepicker v-model="endedAt.data">
                  <label> {{ endedAt.label }} </label>
                </md-datepicker>
              </div>

              <!-- 이메일 폼 -->
              <div class="md-layout-item md-size-25">
                <md-field>
                  <md-icon>{{ email.icon }}</md-icon>
                  <label>{{ email.label }}</label>
                  <md-input v-model="email.data"></md-input>
                </md-field>
              </div>

              <!-- 이름 폼 -->
              <div class="md-layout-item md-size-25">
                <md-field>
                  <md-icon>{{ name.icon }}</md-icon>
                  <label>{{ name.label }}</label>
                  <md-input v-model="name.data"></md-input>
                </md-field>
              </div>

            </template>
          </div>
        </md-card-content>

        <!-- 버튼 -->
        <md-card-actions>
          <md-button @click="submitConditions" class="md-primary md-round"> {{ buttonLabel }} </md-button>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import CardHeader from '../cards/CardHeader.vue';

export default {
  components: {
    CardHeader,
  },
  props: {
    title: String,
  },
  data() {
    return {
      icon: "search",
      buttonLabel: "검색",
      startedAt: {
        label: "시작 날짜",
        data: null,
      },
      endedAt: {
        label: "마지막 날짜",
        data: null,
      },
      name: {
        label: "이름",
        icon: "person",
        data: null,
      },
      email: {
        label: "이메일",
        icon: "mail",
        data: null,
      },
    }
  },
  methods: {
    submitConditions() {
      this.$emit('conditions', {
        startedAt: this.startedAt.data,
        endedAt: this.endedAt.data,
        name: this.name.data,
        email: this.email.data,
      });
    }
  }
};
</script>

<style lang="scss"></style>
